<template>
	<div>
		<c-dialog ref="selector" title="选择资产" height="80vh" :button="false" enable-flex>
			<div class="selector-search-bar">
				<div class="selector-search flex-center">
					<i class="selector-search-icon c-icon-search"></i>
					<input v-model="keyword" class="flex-grow" @input="updateList">
				</div>
			</div>

			<c-scroll ref="scroll" class="flex-grow">
				<c-empty v-if="dataList && !dataList.length"></c-empty>
				<div v-for="(item, i) in dataList" :key="i" :ref="i" class="item flex-center" @click="clickHandle(item)">
					<div class="check flex-center" :class="{'z-crt': currentList.find(crt => crt.id == item.id)}"><i class="c-icon-check"></i></div>
					<div class="flex-grow">
						<p class="ellipsis">{{item.asset_name}}</p>
						<p class="info">资产分类：{{item.asset_category || '-'}}</p>
                        <p class="info">资产编号：{{item.asset_code || '-'}}</p>
					</div>
					<c-file v-if="item.image_url" class="image" :src="item.image_url" media></c-file>
				</div>
			</c-scroll>

			<div class="current flex-between-center" :style="{'z-index': showCurrentList ? 1010 : 90}">
				<div class="flex-center" @click="currentListHandle">
					<span class="total">已选：<span :style="{'color': currentList.length ? '#00ACA9' : ''}">{{currentList.length}}项</span></span>
					<i v-if="currentList.length" class="angle tf-angle-up" :style="{'transform': showCurrentList ? 'rotate(180deg)' : ''}"></i>
				</div>
				<c-button color="main" size="dialog" @click="resolveHandle">确定</c-button>
			</div>
		</c-dialog>

		<c-dialog ref="currentList" :title="`已选中 (${currentList.length})`" :button="false" mask-close @close="currentListClose">
			<c-scroll class="current-list">
				<div v-for="(item, i) in currentList" :key="i" :ref="i" class="item flex-center" @click="currentList.splice(i, 1)">
					<div class="check flex-center" :class="{'z-crt': currentList.find(crt => crt.id == item.id)}"><i class="c-icon-check"></i></div>
					<div class="flex-grow">
						<p class="ellipsis">{{item.asset_name}}</p>
						<p class="info">资产分类：{{item.asset_category || '-'}}</p>
                        <p class="info">资产编号：{{item.asset_code || '-'}}</p>
					</div>
					<c-file v-if="item.image_url" class="image" :src="item.image_url" media></c-file>
				</div>
			</c-scroll>
		</c-dialog>
	</div>
</template>

<script>
	import {debounce} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'assetsSelector',

		props: {
			status: [String, Number],  // 1：空闲、2：占用
			multiple: Boolean
		},

		data() {
			return {
				keyword: '',
				dataList: null,
				currentList: [],
				showCurrentList: false
			}
		},

		methods: {
			open(data = {}) {
				this.$refs.selector.open();
				this.keyword = '';
				this.dataList = null;
				this.currentList = [];
				this.updateList();
			},

			updateList: debounce(function() {
				this.request({
					url: '/fixed_asset/list',
					data: {
                        pageSize: 9999,
						current_status: this.status,
						status: [1],
						keyword: this.keyword.trim()
					},
					success: data => {
						this.dataList = data;
					}
				})
			}, 200),

			clickHandle(data) {
				if (this.multiple) {
					if (this.currentList.find(item => item.id == data.id)) {
						this.currentList.splice(this.currentList.findIndex(item => item.id == data.id), 1);
					} else {
						this.currentList.push(data);
					}
				} else {
					this.currentList = [data];
				}
			},

			currentListHandle() {
				if (this.showCurrentList) {
					this.$refs.currentList.close();
				} else if (this.currentList.length) {
					this.showCurrentList = true;
					this.$refs.currentList.open();
				}
			},

			currentListClose() {
				setTimeout(() => {
					this.showCurrentList = false;
				}, 400);
			},

			resolveHandle() {
				if (!this.currentList.length) {
					this.$message({
						message: '未选择资产'
					});
					return;
				}

				this.$refs.selector.close();
				this.$emit('resolve', this.currentList);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.item {
		gap: .24rem;
		padding: .2rem .24rem;
		font-size: .32rem;

		.check {
			align-self: flex-start;
			box-sizing: border-box;
			width: .4rem;
			height: .4rem;
			border: .04rem solid #ccc;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			box-shadow: 3px 3px 8px 0 rgba(0,0,0,.1);

			&.z-crt {
				border-color: var(--color-main);
				background: var(--color-main);
			}
		}

		.info {
			margin-top: .22rem;
			font-size: .28rem;
			color: #999;
		}

		.image {
			width: .96rem;
			height: .96rem;
			border: none;
		}
	}

	.current {
		gap: .35rem;
		min-height: 1.2rem;
		border-top: 1px solid #eee;
		padding: 0 .32rem var(--safe-area);
		background: #fff;

		&-list {
			height: 50vh;
		}

		.total {
			font-size: .3rem;
			color: #666;
		}

		.angle {
			margin-left: .22rem;
			font-size: .24rem;
			color: #B1BBCF;
		}
	}
</style>
